export const SESSION_STORAGE_KEYS = {
  HealthQuotationData: 'HEALTH_DATA',
};
